<!-- 图片列表页 -->
<template>
  <div>
    <my-header></my-header>
    <classify :classifyId="waterObj.InteralDirId" @getListArray="getListArray"></classify>
    <div v-if="flag">
      <waterfall
        :isWaterfall="true"
        :apiType="3"
        :isPick="true"
        :fileList="{IsHomePage:false,MinClassifies:ListData.MinClassifies,FileClassify:FileClassify,SecondLevelCatelogId:SecondLevelCatelogId,ThirdLevelCatelogId:ListData.ThirdLevelCatelogId,FourLevelCatelogId:ListData.FourLevelCatelogId,ImgExtensType:ListData.ImgExtensType,Sorting:ListData.Sorting,LabelIds:ListData.LabelIds}"
      ></waterfall>
    </div>
    <my-footer></my-footer>
  </div>
</template>
<script>
import classify from "../common/classify";
import waterfall from "../common/waterfall";

export default {
  inject: ["reload"],
  data() {
    return {
      IsHomePage: false,
      flag: true, //重新渲染数据
      waterObj: "",
      FileClassify: "",
      SecondLevelCatelogId: [],
      ListData: {
        ThirdLevelCatelogId: 0,
      },
    };
  },
  components: {
    classify,
    waterfall,
  },
  created() {
    this.waterObj = this.$route.query;
    this.SecondLevelCatelogId[0] = this.$route.query.InteralDirId;
    this.FileClassify = this.$route.query.FileClassify;
    if (this.$route.query.InteralDirId == 12) {
      this.ListData.ThirdLevelCatelogId = "-1";
    }
   if(this.$route.query.ThirdLevelCatelogId&&this.$route.query.ThirdLevelCatelogId==255){
           this.ListData.ThirdLevelCatelogId = "255";

    }
  },
  methods: {
    getListArray(data) {
      this.ListData = data;
      this.flag = false;
      this.$nextTick(function () {
        this.flag = true;
      });
    },
  },

  watch: {
    $route(to, from) {
      this.SecondLevelCatelogId[0] = this.$route.query.InteralDirId;
      this.FileClassify = this.$route.query.FileClassify;
      this.reload();
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/index/picList.vue